//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Moment from 'moment';

export default {
  data: function data() {
    var $el = this;
    return {
      loading: true,
      headers: [],
      fields: [],
      traffic: [],
      from: Moment().startOf('isoWeek'),
      to: Moment().endOf('isoWeek'),
      trafficType: '',
      rangeSelected: 'THIS_WEEK',
      ranges: [{ value: 'TODAY', label: 'Today' }, { value: 'THIS_WEEK', label: 'This Week' }, { value: 'LAST_WEEK', label: 'Last Week' }, { value: 'THIS_MONTH', label: 'This Month' }, { value: 'LAST_MONTH', label: 'Last Month' }, { value: 'THIS_YEAR', label: 'This Year' }, { value: 'LAST_YEAR', label: 'Last Year' }],
      trafficTypes: [{ value: 'UNIT_SHOWN', label: 'Unit Shown' }, { value: 'WALK_IN', label: 'Walk In' }, { value: 'PHONE_CALL', label: 'Phone call' }, { value: 'EMAIL', label: 'Email' }]
    };
  },

  props: ['reportId', 'reportType', 'reportTable'],
  mounted: function mounted() {
    var $el = this;
    this.getReport();
  },

  methods: {
    timeRangeChange: function timeRangeChange(_ref) {
      var start_date = _ref.start_date,
          end_date = _ref.end_date;

      this.from = start_date;
      this.to = end_date;
      this.getReport();
    },
    dateRangeChange: function dateRangeChange($event) {
      switch ($event.target.value) {
        case 'TODAY':
          this.from = Moment().startOf('day');
          this.to = Moment().endOf('day');
          break;
        case 'THIS_WEEK':
          this.from = Moment().startOf('isoWeek');
          this.to = Moment().endOf('isoWeek');
          break;
        case 'LAST_WEEK':
          this.from = Moment().subtract(1, 'week').startOf('isoWeek');
          this.to = Moment().subtract(1, 'week').endOf('isoWeek');
          break;
        case 'THIS_MONTH':
          this.from = Moment().startOf('month');
          this.to = Moment().endOf('month');
          break;
        case 'LAST_MONTH':
          this.from = Moment().subtract(1, 'month').startOf('month');
          this.to = Moment().subtract(1, 'month').endOf('month');
          break;
        case 'THIS_YEAR':
          this.from = Moment().startOf('year');
          this.to = Moment().endOf('year');
          break;
        case 'LAST_YEAR':
          this.from = Moment().subtract(1, 'year').startOf('year');
          this.to = Moment().subtract(1, 'year').endOf('year');
          break;
      }
      this.getReport();
    },
    getReport: function getReport() {
      var $el = this;
      axios.post('/prototype/reporting/get-report', {
        type: this.reportId,
        method: 'traffic',
        traffic_type: this.trafficType,
        start_date: Moment(this.from).format('YYYY-MM-DD'),
        end_date: Moment(this.to).format('YYYY-MM-DD')
      }).then(function (response) {
        if (response.data) {
          $el.headers = response.data.header;
          $el.fields = response.data.field;
          $el.traffic = response.data.result;
          $el.loading = false;
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    exportReport: function exportReport() {
      Event.$emit('export-report', {
        type: this.reportId,
        method: 'traffic',
        traffic_type: this.trafficType,
        start_date: Moment(this.from).format('YYYY-MM-DD'),
        end_date: Moment(this.to).format('YYYY-MM-DD')
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/guest-cards/reports/TrafficDetail.vue
// module id = tMYc
// module chunks = 0 1